import React from "react";
import ContactForm from "../../components/public/ContactForm";
import { useSettings } from "../../lib/useSettings";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export function ContactPage() {
  const { settings: s } = useSettings();
  return (
    <>
      <title>Contact — Kloub'Air Plomberie & Climatisation Grans</title>
      <meta name="description" content="Contactez Kloub'Air Plomberie pour tout projet de climatisation ou plomberie à Grans et 40km autour. Réponse sous 24h."/>
      <section className="pt-14 pb-10 bg-[color:var(--brand-navy)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl md:text-6xl font-black">Contact</h1>
          <p className="mt-4 text-white/80 max-w-2xl">Plombier · Climaticien · Dépanneur — nous vous répondons sous 24h.</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-10">
          <div className="space-y-6">
            {[
              { icon: Phone, label: "Téléphone", value: s?.phone, href: s?.phone ? `tel:${s.phone.replace(/\s/g,"")}` : "#" },
              { icon: Mail, label: "Email", value: s?.email, href: s?.email ? `mailto:${s.email}` : "#" },
              { icon: MapPin, label: "Adresse", value: s?.address_public, href: "#" },
              { icon: Clock, label: "Disponibilité", value: "6 jours sur 7", href: "#" },
            ].map((c, i) => (
              <a key={i} href={c.href} className="flex items-start gap-4 p-5 rounded-2xl border border-[hsl(var(--border))] bg-white hover:border-[color:var(--brand-sky)] transition">
                <div className="w-10 h-10 rounded-full bg-[color:var(--brand-navy)] text-white flex items-center justify-center flex-shrink-0">
                  <c.icon className="w-4 h-4"/>
                </div>
                <div>
                  <div className="text-xs uppercase font-bold tracking-wider text-[hsl(var(--muted-foreground))]">{c.label}</div>
                  <div className="font-display font-bold text-[color:var(--brand-navy)]">{c.value || "—"}</div>
                </div>
              </a>
            ))}
          </div>
          <ContactForm defaultType="contact" title="Écrivez-nous" description="Un conseil, une question, un projet — nous vous répondons rapidement."/>
        </div>
      </section>
    </>
  );
}

export function DevisPage() {
  return (
    <>
      <title>Devis gratuit — Kloub'Air Plomberie & Climatisation</title>
      <meta name="description" content="Demandez votre devis gratuit pour installation climatisation ou plomberie. Réponse sous 24h, sans engagement."/>
      <section className="pt-14 pb-10 bg-[color:var(--brand-navy)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl md:text-6xl font-black">Devis gratuit</h1>
          <p className="mt-4 text-white/80 max-w-2xl">Étude personnalisée · Réponse sous 24h · 100% gratuit et sans engagement.</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <ContactForm defaultType="devis" title="Votre demande de devis" description="Décrivez-nous votre projet — plus vous êtes précis, plus notre devis sera juste."/>
        </div>
      </section>
    </>
  );
}

export function LegalPage({ kind = "mentions" }) {
  const titles = { mentions: "Mentions légales", cgv: "Conditions générales de vente", confidentialite: "Politique de confidentialité" };
  return (
    <>
      <title>{titles[kind]} — Kloub'Air Plomberie</title>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-8 prose">
          <h1 className="font-display text-4xl font-black text-[color:var(--brand-navy)] mb-8">{titles[kind]}</h1>
          <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">
            {kind === "mentions" && (<>
              <strong>Raison sociale :</strong> Kloub'Air Plomberie<br/>
              <strong>Siège :</strong> Grans, 13450 — Bouches-du-Rhône<br/>
              <strong>Directeur de la publication :</strong> François Kloubert<br/>
              <strong>Hébergeur :</strong> Infrastructure cloud France<br/>
              <strong>Contact :</strong> contact@kap-clim.fr · 07 61 66 49 61<br/><br/>
              Le site est édité en langue française. Les contenus, images et marques restent la propriété exclusive de Kloub'Air Plomberie.
            </>)}
            {kind === "cgv" && (<>
              Les présentes conditions régissent les prestations de service fournies par Kloub'Air Plomberie. Chaque intervention fait l'objet d'un devis préalable détaillant les prestations, les délais et le prix TTC. Le devis signé vaut commande. Le paiement s'effectue à la fin des travaux, sauf accord particulier. Garantie décennale sur les installations. Pour toute réclamation, nous contacter par écrit.
            </>)}
            {kind === "confidentialite" && (<>
              Kloub'Air Plomberie respecte votre vie privée et la réglementation RGPD. Les données collectées via nos formulaires (nom, téléphone, email, message) servent exclusivement à traiter votre demande. Elles sont conservées 3 ans maximum et ne sont jamais revendues. Vous disposez d'un droit d'accès, de rectification et de suppression. Écrivez-nous à contact@kap-clim.fr pour exercer ces droits.
            </>)}
          </p>
        </div>
      </section>
    </>
  );
}
